import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_WEB_DATA,
  CREATE_WEB_DATA,
  UPDATE_WEB_DATA,
  DELETE_WEB_DATA,
  UPLOAD_IMAGE_WEB_DATA,
  DELETE_IMAGE_WEB_DATA,
  M_GET,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'updatecommissionlog' })
export default class WebManagementModules extends VuexModule {
  @Action
  async Fetch() {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + FETCH_WEB_DATA,
        method: M_GET,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async Create(params: object) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + CREATE_WEB_DATA,
        method: M_POST,
        data: params,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async Update(params: any) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + UPDATE_WEB_DATA,
        method: M_POST,
        data: params,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async Delete(params: any) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + DELETE_WEB_DATA,
        method: M_POST,
        data: params,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async UploadImg(params: any) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + UPLOAD_IMAGE_WEB_DATA,
        method: M_POST,
        data: params,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async DeleteImg(params: any) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + DELETE_IMAGE_WEB_DATA,
        method: M_POST,
        data: params,
      });
      return data;
    } catch (err) {
      return err;
    }
  }
}
